<template>
  <div id="login">
    <div class="login-l">
      <div class="projectLogo">
        <img :src="staticLogo" id="logo"/>
      </div>
      <!-- 
        <div class="explain">
          <h1>智慧考试新模式</h1>
          <ul>
              <li v-for="item in explainList" :key="item">{{item}}</li>
          </ul>
        </div> 
      -->
    </div>

    <div class="login-r">
      <div class="clientLogo">
        <img :src="logoSrc" alt="" />
      </div>
      <div class="fromLogo">
        <!-- 登录方式 -->
        <div class="login-h1">
          <h1>欢迎登录</h1>
          <div class="changeBtn" v-if="isOpenPhoneLogin">
            <span @click="changeMode('account')" :class="{ active: isActive, account: true }">账号登录</span>
            <span class="changeCenter">|</span>
            <span @click="changeMode('verification')" :class="{ active: !isActive, verification: true }">验证码登录</span>
          </div>
        </div>
        <!-- 登录表单 -->
        <el-form
          :model="isActive ? ruleForm : phoneRuleForm"
          :rules="isActive ? rules : phoneRules"
          :ref="isActive ? 'ruleForm' : 'phoneRuleForm'"
          label-width="100px"
          class="demo-ruleForm"
        >
          <!-- 账户密码登录 -->
          <div v-if="isActive">
            <el-form-item prop="userName">
              <el-input v-model="ruleForm.userName" placeholder="请输入用户名"></el-input>
              <img src="../assets/img/login-username-icon.png" class="login-icon"/>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="ruleForm.password" type="password" placeholder="请输入密码"></el-input>
              <img src="../assets/img/login-password-icon.png" class="login-icon"/>
            </el-form-item>
            <el-form-item prop="imageCheckCode">
              <el-input v-model="ruleForm.imageCheckCode" placeholder="请输入验证码"></el-input>
              <img src="../assets/img/login-code-icon.png" class="login-icon" />
              <img :src="codeSrc" class="code-img" @click="handleCode" />
            </el-form-item>
          </div>
          <!-- 手机号登录 -->
          <div v-else class="verification-box">
            <el-form-item prop="phone">
              <el-input v-model.trim="phoneRuleForm.phone" placeholder="请输入您的注册手机号" @blur="checkAll('phoneRuleForm')" class="input-phone"></el-input>
              <img src="../assets/img/icon-mobile.png" class="login-icon" />
              <span class="login-phone">+86</span>
            </el-form-item>
            <el-form-item prop="phoneCheckCode">
              <el-input v-model="phoneRuleForm.phoneCheckCode" type="text" placeholder="请输入短信验证码"></el-input>
              <div :class="[isgetCode ? 'isgetCode' : 'getCode']" @click="[isgetCode ? getVerCode(phoneRuleForm.phone) : '']">
                {{ countDownText }}
              </div>
              <img src="../assets/img/icon-mobile-code.png" class="login-icon"/>
            </el-form-item>
          </div>
          <!-- 登录按钮 -->
          <el-form-item class="loginBtn" v-if="isActive">
            <el-button type="primary" @click="handleLogin('ruleForm')">登 录</el-button>
          </el-form-item>
          <el-form-item class="loginBtn" v-else>
            <el-button type="primary" @click="phoneLogin('phoneRuleForm')">登 录</el-button>
          </el-form-item>
          <!-- 立即注册, 忘记密码 -->
          <div class="logoBot">
            <div>还没有账号？<span @click="goRegister">立即注册</span></div>
            <span @click="resetPassword"> 忘记密码 </span>
          </div>
        </el-form>
      </div>
      <!-- 版本号 -->
      <div class="copyright">
        ©1998-2022 弘成科技发展有限公司 版权所有
      </div>
    </div>
  </div>
</template>
 
<script>
import crypto from "crypto";
import logoSet from "@/http/logoSet.js";
import { imageCheckCodeOne } from "@/http/api.js";
import { checkPwd_pure, checkPhone } from "@/common/verify.js";
import { logoDefault } from "@/http/logoSet.js";
import { isgetTenantSmsConfig } from "@/http/modules/notice/notice";
export default {
  data() {
    return {
      staticLogo: require('@/assets/img/Afdt-logo.png'),
      // 是否开启验证码登录
      isOpenPhoneLogin: false,
      // 切换登录方式
      isActive: true,
      // 是否开启验证码按钮
      isgetCode: false,
      // 按钮文字
      countDownText: "获取验证码",
      // 距离再次获取验证码的剩余秒数
      count: 120,
      // 租户 Logo 链接
      logoSrc: "",
      // 验证码图片链接
      codeSrc: "",
      // 左侧提示数据
      explainList: [
        "海量云题库，支持多种题型批量导入、智能查重。",
        "大数据算法实现一键组卷，支持多种组卷方式。",
        "人脸识别，严防考试作弊，保障考场纪律。",
      ],
      // 账号密码登录
      ruleForm: {
        authMode: 1,
        userName: "",
        password: "",
        imageCheckCode: "",
        tenant: "",
      },
      // 手机号登录
      phoneRuleForm: {
        authMode: 0,
        phone: "",
        phoneCheckCode: "",
        tenant: this.$route.query.tenant ? this.$route.query.tenant : "",
      },
      // 账密表单验证
      rules: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        imageCheckCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      // 手机号登录表单验证
      phoneRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "change" },
          { validator: checkPhone, trigger: "change" },
        ],
        phoneCheckCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
      },
    };
  },

  watch: {
    // 路由变化监听
    $route: {
      handler: function () {
        // (1) 判断是否切换了租户, 刷新页面
        if (this.$route.query.refresh) {
          window.location.reload();
        }
        // (2) 获取更新的租户信息, tenant 租户信息现已在 permission 中存储
        this.ruleForm.tenant = window.localStorage.getItem('tenant');
        this.phoneRuleForm.tenant = window.localStorage.getItem('tenant');
        // (3) 根据租户改LOGO (武汉成教, 武汉四六级)
        if (this.$route.query.tenant == 'whkjdxcjkw') {
          this.staticLogo = require('@/assets/img/whkjdxcjkw-Logo.png');
        } else if (this.$route.query.tenant == 'whkjdxcjsljbk') {
          this.staticLogo = require('@/assets/img/whkjdxcjsljbk-logo.png');
        }
      },
      immediate: true,
    },
  },

  created() {
    // 清空路由
    this.$store.dispatch("permission/resetRoutesAction");
    // 判断是否是 IE 浏览器
    this.dealIE();
    // 手机号登录倒计时
    let myEndTime = localStorage.getItem("myEndTime");
    myEndTime && this.codeCountDown(myEndTime);
  },

  mounted() {
    // (1) 首次加载配置验证码
    this.codeSrc = `${imageCheckCodeOne}?time=${Math.random()}`;
    // (2) 配置登录表单回车登录
    document.addEventListener("keydown", (e) => {
      if (e.keyCode === 13) {
        if (this.isActive) {
          this.handleLogin("ruleForm");
        } else {
          this.phoneLogin("phoneRuleForm");
        }
      }
    });
    // (3) 获取 Logo 接口
    this.getLogo();
    // (4) 是否开启手机验证码登录
    this.isOpenPhoneVcode();
  },

  methods: {
    /* *** 是否开启手机验证码登录功能 *** */
    isOpenPhoneVcode() {
      isgetTenantSmsConfig({ tenant: this.phoneRuleForm.tenant }).then((res) => {
        this.isOpenPhoneLogin = res.code == 1 ? res.data.loginCheck == 1 : false;
      });
    },

    /* *** 切换登录方式 *** */
    // (1) v == "account" 账号登录
    // (2) v == "verification" 验证码登录
    changeMode(v) {
      this.isActive = v == "account";
    },

    /* *** 是否开启获取验证码按钮 *** */
    checkAll(formName) {
      this.$refs[formName].validateField(["phone"], (valid) => {
        this.isgetCode = !valid;
      });
    },

    /* *** 获取验证码 *** */
    // (1) state 手机号
    getVerCode(state) {
      if (state) {
        let params = {
          type: 1,
          phone: this.phoneRuleForm.phone,
          tenant: this.phoneRuleForm.tenant,
        }
        this.$api.login.phoneCheckCode(params).then((res) => {
          if (res.code == 1) { this.GetCode() }
        })
      } else {
        return false;
      }
    },

    /* *** 倒计时存入缓存,防止刷新重置 *** */
    GetCode() {
      let countDownTime = new Date().getTime() + 120000;
      localStorage.setItem("myEndTime", JSON.stringify(countDownTime));
      this.codeCountDown(countDownTime);
    },

    /* *** 倒计时计算,清除缓存和定时器 *** */
    codeCountDown(countDownTime) {
      this.isgetCode = false;
      this.countDownText = this.count + "秒后获取";
      this.count = Math.ceil((countDownTime - new Date().getTime()) / 1000);
      let time = setTimeout(() => {
        this.count--;
        if (this.count < 1) {
          this.isgetCode = true;
          this.countDownText = "获取验证码";
          this.count = 120;
          localStorage.removeItem("myEndTime");
          clearTimeout(time);
        } else {
          this.codeCountDown(countDownTime);
        }
      }, 1000);
    },

    /* *** 手机验证码登录 *** */
    phoneLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.login.login(this.phoneRuleForm).then((res) => {
            if (res.code == 1) {
              // (1) 存储用户信息 userInfo, 租户信息 tenant
              let userInfo = JSON.stringify(res.data);
              window.localStorage.setItem("userInfo", userInfo);
              window.localStorage.setItem("tenant", this.phoneRuleForm.tenant);
              this.$message.success("登录成功！");
              // (2) roleType == 2 学生端首页 | roleType == 1 管理端首页 | roleType == 5 评阅教师评阅页面
              if (res.data.roleType === 2) {
                this.$router.push({ name: "home" });
              } else if (res.data.roleType === 5) {
                this.$router.push({ path: "/review" })
              } else {
                this.$router.push({ name: "index" });
              }
            }
          });
        } else {
          return false;
        }
      });
    },

    /* *** 判断是否是IE浏览器 *** */
    dealIE() {
      if (window.isIE) {
        this.$confirm(
          "检测到当前浏览器适配较差，为更好的使用系统，推荐使用谷歌浏览器，如果是360，搜狗等浏览器，请切换极速模式后刷新页面使用。",
          "重要提示",
          {
            confirmButtonText: "下载谷歌浏览器",
            cancelButtonText: "换浏览器打开",
            type: "warning",
          }
        ).then(async () => {
            window.location.href = "https://www.google.cn/intl/zh-CN/chrome/";
          }).catch(() => {
            window.close();
          });
      }
    },

    /* *** 获取院校 Logo *** */
    getLogo() {
      logoSet("login", this.ruleForm.tenant).then(({ code, data }) => {
        this.logoSrc = code == 1 ? data : logoDefault("login");
      }).catch(() => {
        this.logoSrc = logoDefault("login");
      });
    },

    /* *** 配置验证码 *** */
    handleCode() {
      this.codeSrc = `${imageCheckCodeOne}?time=${Math.random()}`;
    },

    /* *** 账号密码登录 *** */
    handleLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // (1) 配置用户登录信息, 密码 md5 加密
          this.ruleForm.userName = this.ruleForm.userName.trim();
          let { password, ...parmas } = this.ruleForm;
          let md5Password = password;
          const md5 = crypto.createHash("md5");
          md5.update(md5Password);
          md5Password = md5.digest("hex");
          let queryRuleForm = {
            password: md5Password,
            ...parmas,
          };
          // (2) 二次判断租户名
          if (!this.ruleForm.tenant) {
            this.$message.error("网页地址错误，请输入正确的网址！");
            return false;
          }
          // (3) 执行登录
          this.$api.login.login(queryRuleForm).then((res) => {
            if (res.code) {
              let userInfo = JSON.stringify(res.data);
              window.localStorage.setItem("userInfo", userInfo);
              window.localStorage.setItem("tenant", this.ruleForm.tenant);
              this.$message.success("登录成功！")
              // (4) roleType == 2 学生端首页 | roleType == 1 管理端首页 | roleType == 5 评阅教师评阅页面
              if (res.data.roleType === 2) {
                this.goStudent(password);
              } else if (res.data.roleType === 5) {
                this.$router.push({ name: "review" })
              } else {
                this.$router.push({ name: "index" });
              }
            } else {
              // (5) 登录失败, 请求验证码
              this.codeSrc = `${imageCheckCodeOne}?time=${Math.random()}`;
              this.ruleForm.imageCheckCode = "";
            }
          })
        } else {
          return false;
        }
      });
    },

    /* *** 跳转学生端 => 是否修改密码 *** */
    goStudent(password) {
      this.$router.push({ name: checkPwd_pure(password) ? "home" : "updatePassword" });
    },

    /* *** 注册 *** */
    goRegister() {
      this.$router.push({
        name: "register",
        query: { tenant: this.ruleForm.tenant },
      });
    },

    /* *** 找回密码 *** */
    resetPassword() {
      this.$router.push({
        name: "resetPassword",
        query: { tenant: this.ruleForm.tenant },
      });
    },

  },
};
</script>

<style lang="less" scoped>
#logo {
  max-height: 60px;
  width: auto;
}
.clientLogo {
  height: 60px;
  img {
    height: 100%;
    width: auto;
  }
}
#login {
  width: 100%;
  height: 100%;
  display: flex;
  .login-l {
    width: 25%;
    height: 100%;
    padding: 46px 48px;
    box-sizing: border-box;
    background: url("../assets/img/login-l-bg2.jpg") bottom center no-repeat;
    background-size: cover;
    .explain {
      h1 {
        margin-top: 152px;
        margin-bottom: 36px;
        font-size: 28px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.95);
      }
      li {
        font-size: 16px;
        color: rgba(255, 255, 255, 0.75);
        position: relative;
        margin-bottom: 16px;
        margin-left: 10px;
      }
      li:after {
        content: " ";
        position: absolute;
        left: -10px;
        top: 10px;
        width: 5px;
        height: 5px;
        background: rgba(255, 255, 255, 0.75);
        border-radius: 50%;
      }
    }
  }
  .login-r {
    flex: 1;
    position: relative;
    background: url("../assets/img/login-r-bg.jpg") top center no-repeat;
    background-size: cover;
    padding: 44px 50px 36px 50px;
    .fromLogo {
      width: 480px;
      height: 460px;
      background: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 8px 36px 0px rgba(0, 62, 153, 0.1),
        -1px 1px 1px 0px rgba(255, 255, 255, 0.5);
      border-radius: 12px;
      padding: 40px 60px;
      box-sizing: border-box;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      /* 登录方式页面切换 */
      .login-h1 {
        display: flex;
        justify-content: space-between;
        h1 {
          font-weight: 600;
          color: #2d2f33;
          font-size: 28px;
          margin-bottom: 32px;
          display: inline-block;
        }
        .changeBtn {
          display: flex;
          align-items: center;
          width: 175px;
          height: 40px;
          .account {
            margin-right: 20px;
            color: #737780;
            font-weight: 500;
            cursor: pointer;
          }
          .verification {
            color: #737780;
            font-weight: 500;
            cursor: pointer;
          }
          .changeCenter {
            margin-right: 20px;
            color: #737780;
            font-weight: 500;
          }
          .active {
            color: #0b66e6;
            position: relative;
            cursor: pointer;
          }
          .active::after {
            content: "";
            position: absolute;
            left: 50%;
            top: auto;
            bottom: -4px;
            right: auto;
            height: 2px;
            width: 18px;
            background-color: #0b66e6;
            transform: translate(-50%);
          }
        }
      }
      // 新增按钮
      .demo-ruleForm {
        .verification-box {
          padding-top: 64px;
          box-sizing: border-box;
          height: 168px;
        }
        /* ***** 获取验证码按钮样式 ***** */
        .isgetCode {
          text-align: right;
          font-size: 14px;
          line-height: 20px;
          width: 84px;
          height: 20px;
          position: absolute;
          right: 12px;
          top: 10px;
          color: #006aff;
          cursor: pointer;
        }
        .getCode {
          text-align: right;
          font-size: 14px;
          line-height: 20px;
          width: 84px;
          height: 20px;
          position: absolute;
          right: 12px;
          top: 10px;
          color: #9299a6;
          cursor: not-allowed;
        }

        /deep/ .el-form-item__content {
          margin-left: 0 !important;
        }
        .el-form-item {
          position: relative;
          margin-bottom: 24px !important;
          .input-phone /deep/ .el-input__inner {
            border: 0 !important;
            border-bottom: 1px solid #e6e9f2 !important;
            background: transparent;
            border-radius: 0;
            width: 100%;
            height: 40px;
            padding: 8px 30px 8px 74px !important;
            line-height: 24px;
          }
          .login-icon {
            width: 24px;
            height: 24px;
            position: absolute;
            top: 8px;
            left: 6px;
            color: #c2c6cc;
          }
          .login-phone {
            width: 24px;
            height: 40px;
            color: #333 !important;
            position: absolute;
            left: 32px;
            color: #c2c6cc;
          }
          i {
            position: absolute;
            top: 14px;
            left: 10px;
            color: #c2c6cc;
          }
          /deep/ .el-input {
            width: 100%;
            height: 40px;
            line-height: 40px;
          }
          /deep/ .el-input__inner {
            border: 0 !important;
            border-bottom: 1px solid #e6e9f2 !important;
            background: transparent;
            border-radius: 0;
            width: 100%;
            height: 40px;
            padding: 8px 30px 8px 34px !important;
            line-height: 24px;
          }
          /deep/ .el-input__inner:focus {
            border-bottom: 1px solid #c2c6cc !important;
          }
          .code-img {
            position: absolute;
            top: 8px;
            right: 10px;
            width: 80px;
            height: 30px;
          }
          /deep/ .el-button--primary {
            span {
              font-size: 20px;
            }
            /*background-color: #006AFF;*/
            width: 100%;
            height: 52px;
            border-radius: 26px;
          }
          /deep/ .el-button--primary:hover {
            background-color: #2680ff;
          }
        }
        .loginBtn {
          margin-top: 48px;
        }
        .logoBot {
          display: flex;
          justify-content: space-between;
          color: #9299a6;
          font-size: 14px;
          span {
            color: #006aff;
            cursor: pointer;
          }
        }
      }
    }
    .copyright {
      font-size: 14px;
      color: #9299a6;
      text-align: center;
      position: absolute;
      left: 50%;
      bottom: 36px;
      transform: translateX(-50%);
    }
  }
}
</style>
